import { businessErrorFactory, BusinessError } from '../../../../../../../common/business-error';

const SET_NOTIFICATION_SETTINGS_UPDATE_UNEXPECTED_ERROR =
  // eslint-disable-next-line max-len
  'Sorry we ran into an unexpected error while processing your low balance notification settings update. Please try again. If the problem still persists, contact with support.';

export const getLowBalanceNotificationSettingsUpdateBusinessError = (): BusinessError =>
  businessErrorFactory({
    message: SET_NOTIFICATION_SETTINGS_UPDATE_UNEXPECTED_ERROR,
    severity: 'error'
  });
